<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" > Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Vehicles </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/mmodels/index"> Manage Vehicles  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{ all_data ? all_data.id : '' }} </h6>
                <!-- <img :src="imageUrl" alt="Your Image">
                <img src="../../../public/img/evenware-logo.png" width="140px" alt="Evenware Logo"> -->
            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->




                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       
                  <button   @click="Back()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad">  Back</button>
                  
                  <button   @click="Update()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
              
                  <button  @click="Delete()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Delete</button>
                
                 
            
                </div>
                <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      
     bottom>
    <template   #modal-title>
     
      <h3 >Confirm !</h3>

      
  
    </template>
    
    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm this item?</h5>
    </div>
    <hr>
    
    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>

  
  </b-modal>

  <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else-if="all_data && all_data.id" class="mt-1">
                  <div >




                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  table-responsive">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>HS Code </b></td>
                           <td>{{ all_data.hs_code}}</td> 
                          </tr>
                          <tr>
                            <td><b>Category</b></td>
                           <td>{{ all_data.category }}</td> 
                          </tr>
                          <tr>
                            <td><b>Country of Origen</b></td>
                           <td>{{ all_data.country }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Year of Manufacture</b></td>
                           <td>{{ all_data.year }}</td> 
                          </tr>
                          <tr>
                            <td><b>Brand Name </b></td>
                           <td>{{ all_data.brand_name || (all_data.relatedToBrand ? all_data.relatedToBrand.brand_name : '') }}</td>
                          </tr>
                          
                          <tr>
                            <td><b>Model Name</b></td>
                           <td>{{ all_data.modelname}}</td> 
                          </tr>
                          <tr>
                            <td><b>Model Name for MTA2 </b></td>
                           <td>{{ all_data.mta2modelname }} </td> 
                          </tr>
                          <tr>
                            <td><b>Engine </b></td>
                           <td>{{ all_data.engine }}</td> 
                          </tr>
                          <tr>
                            <td><b>Horse Power </b></td>
                           <td>{{ all_data.hp }}</td> 
                          </tr>
                          <tr>
                            <td><b>Type</b></td>
                           <td>{{ all_data.type }}</td> 
                          </tr>
                          <tr>
                            <td><b>Cylinder Capacity</b></td>
                           <td>{{ all_data.cylinder_capacity }}</td> 
                          </tr>
                          <tr>
                            <td><b>Rated Output</b></td>
                           <td>{{ all_data.rated_op }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Max Output</b></td>
                            <td>{{ all_data.max_op }}</td> 
                          </tr>
                          <tr>
                            <td><b>Fuel</b></td>
                            <td>{{ all_data.fuel }}</td> 
                          </tr>
                          <tr>
                            <td><b>Cooling System</b></td>
                            <td>{{ all_data.cooling_system }}</td> 
                          </tr>
                          <tr>
                            <td><b>Power Transmission System</b></td>
                            <td>{{ all_data.pts }}</td> 
                          </tr>
                          <tr>
                            <td><b>Main Clutch</b></td>
                            <td>{{ all_data.main_clutch }}</td> 
                          </tr>
                          <tr>
                            <td><b>Steering Clutch</b></td>
                            <td>{{ all_data.steering_clutch }}</td> 
                          </tr>
                          <tr>
                            <td><b>Forward Speed</b></td>
                            <td>{{ all_data.f_speed }}</td> 
                          </tr>
                          <tr>
                            <td><b>Reverse Speed</b></td>
                            <td>{{ all_data.r_speed }}</td> 
                          </tr>
                          <tr>
                            <td><b>Tilling Speed</b></td>
                            <td>{{ all_data.t_speed }}</td> 
                          </tr>
                          <tr>
                            <td><b>Full Tank Capacity</b></td>
                            <td>{{ all_data.full_tank_capacity }}</td> 
                          </tr>
                          <tr>
                            <td><b>Starting System</b></td>
                            <td>{{ all_data.starting_system }}</td> 
                          </tr>
                          <tr>
                            <td><b>Electrical System</b></td>
                            <td>{{ all_data.electical_system }}</td> 
                          </tr>
                          <tr>
                            <td><b>Lamp</b></td>
                            <td>{{ all_data.lamp }}</td> 
                          </tr>
                          <tr>
                            <td><b>Wheels</b></td>
                            <td>{{ all_data.wheels }}</td> 
                          </tr>
                          <tr>
                            <td><b>Wheels Tread</b></td>
                            <td>{{ all_data.wheels_tread }}</td> 
                          </tr>
                          <tr>
                            <td><b>Wheel Base</b></td>
                            <td>{{ all_data.wheel_base }}</td> 
                          </tr>
                          <tr>
                            <td><b>Tyre Size Front</b></td>
                            <td>{{ all_data.f_tyre_size }}</td> 
                          </tr>
                          <tr>
                            <td><b>Front D/S</b></td>
                            <td>{{ all_data.f_ds }}</td> 
                          </tr>
                          <tr>
                            <td><b>Tyre Size Rear</b></td>
                            <td>{{ all_data.r_tyre_size }}</td> 
                          </tr>
                          <tr>
                            <td><b>Rear D/S</b></td>
                            <td>{{ all_data.r_ds }}</td> 
                          </tr>
                          
                          <tr>
                            <td><b>B Type</b></td>
                            <td>{{ all_data.b_type }}</td> 
                          </tr>
                          <tr>
                            <td><b>Length (cm)</b></td>
                            <td>{{ all_data.length }}</td> 
                          </tr>
                          <tr>
                            <td><b>Width (cm)</b></td>
                            <td>{{ all_data.width }}</td> 
                          </tr>
                          <tr>
                            <td><b>Height (cm)</b></td>
                            <td>{{ all_data.height }}</td> 
                          </tr>
                          <tr>
                            <td><b>Tilling Width and No. of blades</b></td>
                            <td>{{ all_data.tillingw_blades }}</td> 
                          </tr>
                          
                          <tr>
                            <td><b>Weight Unit</b></td>
                            <td>{{ all_data.w_unit }}</td> 
                          </tr>
                          <tr>
                            <td><b>Weight</b></td>
                            <td>{{ all_data.weight }}</td> 
                          </tr>
                          <tr>
                            <td><b>Weight (without engine)</b></td>
                            <td>{{ all_data.grw }}</td> 
                          </tr>
                          <tr>
                            <td><b>GrossWeight Unit</b></td>
                            <td>{{ all_data.gw_unit }}</td> 
                          </tr>
                          <tr>
                            <td><b>Pay Load</b></td>
                            <td>{{ all_data.py_load }}</td> 
                          </tr>
                          <tr>
                            <td><b>Pay Load Unit</b></td>
                            <td>{{ all_data.upy_load }}</td> 
                          </tr>
                          <tr>
                            <td><b>Show Inquiry</b></td>
                            <td>{{ all_data.show_inquiry }}</td> 
                          </tr>
                          <tr>
                            <td><b>Class Of Vehicle</b></td>
                            <td>{{ all_data.classOfVehicleId }}</td> 
                          </tr>
                          <tr>
                            <td><b>Photo Type</b></td>
                            <td>{{ all_data.phototype }}</td> 
                          </tr>
                          <tr>
                            <td><b>Seating Capacity</b></td>
                            <td>{{ all_data.seating }}</td> 
                          </tr>
                          <tr>
                            <td><b>Driving Side</b></td>
                            <td>{{ all_data.driving_side }}</td> 
                          </tr>
                          <tr>
                            <td><b>Options</b></td>
                            <td>{{ all_data.options }}</td> 
                          </tr>
                          <tr>
                            <td><b>Price (Without Additional Charges)</b></td>
                            <td>{{ all_data.price }}</td> 
                          </tr>
                          <tr>
                            <td><b>Dealer Commission</b></td>
                            <td>{{ all_data.dealer_commission }}</td> 
                          </tr>
                          <tr>
                            <td><b>Transport</b></td>
                            <td>{{ all_data.transport }}</td> 
                          </tr>
                          
                          <tr>
                            <td><b>RMV Charge</b></td>
                            <td>{{ all_data.registration }}</td> 
                          </tr>
                          <tr>
                            <td><b>Insuarance Fee</b></td>
                            <td>{{ all_data.insuarancefee }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created Date</b></td>
                            <td>{{ all_data.createddate }}</td> 
                          </tr>
                          
                         
                           
                        </tbody>
                 
                 
                      </table>


                      </div>
                    </div>
                     






                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>

                            <div class="table-responsive"> 
                            
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>

                          </table>

</div>
                        </div>
                    </div>



                

          






   

<br><br>





                




                </div>

                </div>
                <div v-if="!isLoading && !(all_data && all_data.id)" class="card custom_bdr_rds shadow p-2">
                  <div class="card-body text-center">There are no records to show.</div>
                </div>
              </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
   import jsPDF from 'jspdf';
   import 'jspdf-autotable';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.models()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            username:authService.isUsername(),
            'id':this.$route.query.id,
            total:{},
            all_data:{},
            category:{},
            brand:{},
            supplier:{},
            status:{},
            user:{},
            crm:{},
            details:[],
            mservicelogs:[],
            trans:[],
            width:5,
            height:5,
            isLoading: true,
            infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },

        // imageUrl: '/img/evenware-logo.png' 
           
          }
    
        },
        components :{
         
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

          
          generatePDF() {
    
      const doc = new jsPDF();

      function addPageBorders(doc) {
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Set the border style
    doc.setDrawColor(71, 144, 255); // Black color
    doc.setLineWidth(15); // Border width

    // Draw a line at the top of the page
    doc.line(0, 0, pageWidth, 0);
    // Draw a line at the bottom of the page
    doc.line(0, pageHeight, pageWidth, pageHeight);
}
     // Update this with your image URL or file path
   
      var img = new Image()
    img.src = '/img/evenware-logo.png'
    const imageWidth = doc.internal.pageSize.getWidth() - 550; // Adjust 20 if you need margins
  const imageHeight = (imageWidth * 3) / 4; // Assuming the aspect ratio is 4:3, adjust as needed
  
  doc.addImage(img, 'png', 10, 13, imageWidth, imageHeight);
  doc.setFontSize(18);
  doc.setFont('Helvetica', 'bold');
  doc.text('QUOTATION', 105, 30, null, null, 'center');
  doc.setFontSize(12);
  
  doc.text('Demonstration System', 10, 45, null, null);

  doc.setFont('Helvetica', 'normal');
  doc.setFontSize(8);
  doc.text('No 08, Rodrigo Mawatha,', 10, 48, null, null);
  doc.text('Nawala Road,', 10, 51, null, null);
  doc.text('Rajagiriya,', 10, 54, null, null);
  doc.text('Colombo 08,', 10, 57, null, null);
  doc.text('Sri Lanka', 10, 60, null, null);
  doc.text('Tel : 0112 806 776-9,', 10, 63, null, null);
  doc.text('Web : colombo@cmc.slt.lk ,', 10, 66, null, null);


  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Quotation To:', 85, 45, null, null);
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.relatedToCustomer.C_name, 85, 48, null, null);
  doc.text(this.all_data.enduser_address, 85, 51, null, null);

  
  
 

  
  
  

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Quotation Code:', 200, 45, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.qu_code, 200, 49, null, null, 'right');


  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Sales Person:', 200, 53, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.relatedToSalesperson.name, 200, 56, null, null, 'right');

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Payment Terms:', 200, 60, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.payment_method, 200, 63, null, null, 'right');
  
  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Validity Period:', 200, 67, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.validity_period, 200, 70, null, null, 'right');




  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Date:', 200, 74, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.received_date, 200, 77, null, null, 'right');
 
  const tableData = [
        ['No', 'Product Code', 'Product Description', 'Price', 'Qty', 'Discount %', 'Line Amount']
    ];
    

    this.details.forEach(detail => {
        tableData.push([
            detail.no,
            detail.P_code,
            detail.P_description,
            { content: detail.price, styles: { halign: 'right' } },
            { content: detail.qty, styles: { halign: 'right' } },
            { content: detail.line_discount, styles: { halign: 'right' } },
           
         
            { content: detail.line_amount, styles: { halign: 'right' } },
           
           
          
        ]);
    });

        // Add table to the PDF
        doc.autoTable({
            startY: 85, // Y position to start the table
            head: [tableData[0]], // Table header
            body: tableData.slice(1),
            addPageContent: function(data) {
        addPageBorders(doc); // Call the function to add page borders
    },
    styles: {
        font: 'Helvetica',
        fontSize:8,
    },
            // Table data excluding header
        });
 
        
        const tableBottomY = doc.lastAutoTable.finalY;

        doc.setFontSize(8);
        doc.setFont('Helvetica', 'bold');
        doc.text('Sub Total: '+this.total.total_line_amount, 195, tableBottomY+10, null, null, 'right');

        doc.setFontSize(8);
        doc.setFont('Helvetica', 'bold');
        doc.text('Special Discount: '+this.total.special_discount, 195, tableBottomY+18, null, null, 'right');

        doc.setFontSize(8);
        doc.setFont('Helvetica', 'bold');
        doc.text('Total :'+this.total.sub_total, 195, tableBottomY+26, null, null, 'right');

        doc.setFontSize(9);
        doc.setFont('Helvetica', 'normal');
        doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY+45, null, null);
        doc.text('* Settlement should be made within 5 days', 10, tableBottomY+50, null, null);
        doc.text('* Any complaints should be informed within 3 days after receiving the goods.', 10, tableBottomY+55, null, null);
        doc.text('* Complaints after 3 days will not be accepted under any circumstances.', 10, tableBottomY+60, null, null);
        doc.text('* Bank Details : Commercial Bank (7056), Old Moor Street Branch (017), A/C No. 100 039 2638. ', 10, tableBottomY+65, null, null);
        doc.text('* The above Invoice is inclusive of all taxes.', 10, tableBottomY+70, null, null);
        


  
        doc.output('dataurlnewwindow');



    },
    


     async crmCreate() {
       
    
       try {
         const { data} = await  axios.post('/squatation/crmcreate?id='+this.id,{crm:this.crm,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
          
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },



          async Update(){
        this.$router.push('/mmodels/update?id='+this.id);
      },
          async Back(){
        this.$router.push('/mmodels/index');
      },
          async Delete(){
        
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/mmodels/delete?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         if(data.status==200){
            this.models();
        }
      
       
        
      } catch (error) {
        console.log(error.response);
      }
      },




      async Confimmodel(){
        this.infoModal1.content = this.id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },
       

            async models(id) {
      
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/mmodels/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.all_data = data.all_data
         this.isLoading = false
        //  this.all_data = data.all_data
        //  this.details = data.details
        //  this.total = data.total
        //  this.mservicelogs = data.mservicelogs
       
        
      } catch (error) {
        console.log(error.response);
        this.all_data = {};
        this.isLoading = false;
      }
    },

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>
